<template>
  <div>
    <div v-if="form"
      style="text-align: right;"
      dir="rtl"
    >
      <div>
        <p class="bold">History Company</p>
        <history-companies-search-box @selected="selectHistoryCompany" :selected_history_company_name="selected_history_company_name"></history-companies-search-box>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import HistoryCompaniesSearchBox from '@/components/HistoryCompaniesSearchBox'
export default {
  props: ['payload'],
  name: 'company-history-companies-form',
  data () {
    return {
      is_loading: false,
      form: undefined,
      selected_history_company_name: '',
      company_id: this.payload.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: '',
          history_company: {}
        })
        return
      }
      this.$network_utils.getHistoryCompany(this.payload.data.id)
        .then(response => {
          this.setForm(response)
          this.selected_history_company_name = response.name
          this.selectHistoryCompany(response)
        })
    },
    setForm (form_data) {
      this.form = new this.$form({
        history_company: {
          fields: {
            history_company_id: {
              value: form_data.id,
              has_error: false,
              validations: []
            },
            current_company_id: {
              value: this.payload.company_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/history_companies/' + form_data.id,
            headers: 'company_headers'
          },
          is_used: true
        }
      })
    },
    selectHistoryCompany (history_company) {
      this.form.data.history_company.fields.history_company_id.value = history_company.id
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.$utils.emit('show_toast', { text: 'success' })
        this.is_loading = false
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    HistoryCompaniesSearchBox
  }
}
</script>
